<script setup lang="ts">
import { computed } from "vue";
import LucideIcon from "@/components/LucideIcon.vue";
import { PandoSwitch } from "@/components/ui/switch";
import { PandoTooltip } from "@/components/ui/tooltip";
import { useTheme } from "@/composables/useTheme";

const { theme, toggleTheme } = useTheme();

const isDark = computed(() => theme.value === "dark");
</script>

<template>
  <PandoTooltip content="Toggle light/dark mode">
    <div class="flex items-center gap-2">
      <span class="text-sm text-muted-foreground">
        <LucideIcon :name="isDark ? 'moon' : 'sun'" :size="16" />
      </span>
      <PandoSwitch
        :modelValue="isDark"
        aria-label="Toggle theme"
        @update:model-value="toggleTheme"
      />
    </div>
  </PandoTooltip>
</template>
